(function () {
    "use strict";

    const CONFIG = {
      maxToasts: 4,
      defaultDuration: 3000,
      containerClass: "eqx-toast-container"
    };

    function getContainer() {
      let container = document.querySelector("." + CONFIG.containerClass);

      if (!container) {
        container = document.createElement("div");
        container.className = CONFIG.containerClass;
        document.body.appendChild(container);
      }

      return container;
    }

    function removeOldToasts(container) {
      const toasts = container.querySelectorAll(".eqx-toast");
      if (toasts.length >= CONFIG.maxToasts) {
        toasts[0].remove();
      }
    }

    function createToast(options = {}) {
      try {
        const {
          message = "",
          title = "",
          icon = "",
          theme = "dark",
          type = "",
          duration = CONFIG.defaultDuration
        } = options;

        if (!message && !title) return;

        const container = getContainer();
        removeOldToasts(container);

        const toast = document.createElement("div");

        let className = "eqx-toast";

        if (type) className += ` eqx-${type}`;
        else className += ` ${theme}`;

        toast.className = className;

        toast.innerHTML = `
          ${icon ? `<div class="eqx-toast-icon">${icon}</div>` : ""}
          <div class="eqx-toast-content">
            ${title ? `<div class="eqx-toast-title">${title}</div>` : ""}
            ${message ? `<div class="eqx-toast-message">${message}</div>` : ""}
          </div>
          <span class="eqx-toast-close">&times;</span>
        `;

        container.appendChild(toast);

        requestAnimationFrame(() => {
          toast.classList.add("show");
        });

        let remaining = duration;
        let startTime;
        let timer;

        function removeToast() {
          toast.classList.remove("show");
          toast.classList.add("hide");
          setTimeout(() => toast.remove(), 300);
        }

        function startTimer() {
          startTime = Date.now();
          timer = setTimeout(removeToast, remaining);
        }

        function pauseTimer() {
          clearTimeout(timer);
          remaining -= Date.now() - startTime;
        }

        startTimer();

        toast.addEventListener("mouseenter", pauseTimer);
        toast.addEventListener("mouseleave", startTimer);

        toast.querySelector(".eqx-toast-close").onclick = function () {
          clearTimeout(timer);
          removeToast();
        };

      } catch (err) {
        console.error("eqxToast error:", err);
      }
    }

    window.eqxToast = {
      show: createToast,
      success: (m, o={}) => createToast({ message: m, type: "success", icon: "", ...o }),
      error: (m, o={}) => createToast({ message: m, type: "error", icon: "", ...o }),
      info: (m, o={}) => createToast({ message: m, type: "info", icon: "", ...o }),
      warning: (m, o={}) => createToast({ message: m, type: "warning", icon: "", ...o })
    };

  })();